import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import coin from './../../icons/menus/profile.svg';
import cupon from './../../icons/menus/cupon.svg';
import settings from './../../icons/menus/settings.svg';
import home from './../../icons/menus/home.svg';

import './zuno-menu.scss';

const BottomMenu = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const menuList = [
        {
            icon: home,
            name: 'home',
            link: '/home',
            title: 'Home'
        },
        {
            icon: settings,
            name: 'settings',
            link: '/settings',
            title: 'Settings'
        },
        {
            icon: cupon,
            name: 'cupon',
            link: '/coupons',
            title: 'Coupons'
        },
        {
            icon: coin,
            name: 'profile',
            link: '/profile',
            title: 'Profile'
        }
    ];

    const getActiveMenu = () => {
        const currentPath = location.pathname.toLowerCase();
        const activeItem = menuList.find(item => currentPath.startsWith(item.link));
        return activeItem?.name || '';
    };

    const activeMenu = getActiveMenu();

    return (
        <div className="zuno-menu d-flex">
            {menuList.map((e, index) => (
                <div
                    key={index}
                    className={"zuno-icons " + (activeMenu === e.name ? 'active' : '')}
                    onClick={() => navigate(e.link)}
                >
                    {activeMenu === e.name && <div className="zuno-menu-integator" />}
                    <img src={e.icon} height={22} />
                    <p className="mt-1">{e.title}</p>
                </div>
            ))}
        </div>
    );
};

export default BottomMenu;
